import { MessageCircle } from "lucide-react";
import {
  BaseAppointmentAction,
  AppointmentActionCategory,
  UserRole,
  AppointmentActionContext,
  AppointmentActionPayload,
  AppointmentActionResult,
} from "../core/base-action";
import { AppointmentsRepository } from "@/repositories/appointments.repository";

export class AddCommentAction extends BaseAppointmentAction {
  readonly config = {
    id: "add_comment",
    label: "Add Comment",
    description: "Add a comment to this appointment",
    icon: MessageCircle,
    category: AppointmentActionCategory.COMMUNICATION,
    permissions: {
      requiredRole: [UserRole.PMC, UserRole.VENDOR, UserRole.SUBS],
    },
    requiresDialog: true,
    variant: "default" as const,
  };

  validatePayload(payload?: AppointmentActionPayload): string | null {
    if (!payload?.comment?.trim()) {
      return "Comment cannot be empty";
    }
    return null;
  }

  getDialogComponent(): string {
    return "AddCommentDialog";
  }

  async execute(
    context: AppointmentActionContext,
    payload?: AppointmentActionPayload
  ): Promise<AppointmentActionResult> {
    try {
      const { comment, audience } = payload || {};

      await AppointmentsRepository.addNote(context.appointmentId, comment, audience);

      return {
        success: true,
        message: "Comment added successfully",
      };
    } catch (error: any) {
      return {
        success: false,
        message: error.message || "Failed to add comment",
      };
    }
  }
}
